import { Injectable } from '@angular/core';
import { ApiService } from '@meddatacore/common';
import { DataSourceResponse, Invite } from '../../models';


@Injectable({ providedIn: 'root' })
export class InvitesService extends ApiService {
    endPoint = 'api/invites';

    getInvites(page = 1, pageSize = 10) {
        return this.http.get<DataSourceResponse<Invite>>(`${this.commonBaseURL}/${this.endPoint}?page=${page}&pageSize=${pageSize}`);
    }

    getInvite(id: string) {
        return this.http.get<Invite>(`${this.commonBaseURL}/${this.endPoint}/${id}`);
    }

    accept(id: string) {
        return this.http.post(`${this.commonBaseURL}/${this.endPoint}/${id}/accept`, {});
    }

    refuse(id: string) {
        return this.http.post(`${this.commonBaseURL}/${this.endPoint}/${id}/refuse`, {});
    }
}
